import { Typography } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { Inline, Tag } from '@superdispatch/ui';
import styled from 'styled-components';

const EditIcon = styled(Edit)`
  font-size: 16px;
`;

export function EditedByShipperTag() {
  return (
    <Tag color="yellow" variant="bold">
      <Inline space="xxsmall" verticalAlign="center" noWrap={true}>
        <EditIcon />
        <Typography variant="h5">Edited by Shipper</Typography>
      </Inline>
    </Tag>
  );
}
